import { Components, Theme } from "@mui/material";

export const MuiAccordion: Components<
  Omit<Theme, "components">
>["MuiAccordion"] = {
  styleOverrides: {
    root: {},
  },
};
